import { faker } from '@faker-js/faker'

import { getWordItem } from './WordItem'

import { AdminLucybotResponse } from '../../contracts/lucybot'
import { asBuilder } from '../asBuilder'

export const getLucybotExamine = asBuilder((): AdminLucybotResponse => {
  return {
    succeeded: faker.datatype.boolean(),
    data: {
      allDescriptionList: faker.helpers.multiple(() => faker.image.url()),
      badList: faker.helpers.multiple(getWordItem),
    },
  }
})
